import React from 'react';
import PropTypes from 'prop-types';
import Participant, { ParticipantPropType } from './Participant';

import styles from './Participants.module.scss';

const Participants = ({ participants, hostParticipant, appointment, gridView }) => {
    return (
        <div className={gridView ? styles['grid-view'] : styles.participants}>
            {participants.map((participant) => (
                <Participant
                    hostParticipant={hostParticipant}
                    participant={participant}
                    key={participant.sid}
                    appointment={appointment}
                    gridView={gridView}
                />
            ))}
        </div>
    );
};

Participants.displayName = Participants;
Participants.propTypes = {
    participants: PropTypes.arrayOf(ParticipantPropType),
};
Participants.defaultProps = {
    participants: [],
};

export default Participants;
